import { render, staticRenderFns } from "./OpenEndedAnswers.vue?vue&type=template&id=5181f304&"
import script from "./OpenEndedAnswers.vue?vue&type=script&lang=js&"
export * from "./OpenEndedAnswers.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedAnswers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports